import { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setSignupData,
  setVerificationStep,
} from "../../store/slices/signupSlice";
import { logout } from "../../store/slices/authSlice";

import {
  agency,
  agent,
  club,
  lawyer,
  organizer,
  player,
  staff,
} from "../../constants/icons";

const AccountTypeStep = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const accountTypes = [
    {
      id: "agency",
      icon: agency,
      label: "Agency",
    },
    {
      id: "agent",
      icon: agent,
      label: "Agent",
    },
    {
      id: "club",
      icon: club,
      label: "Club",
    },
    {
      id: "lawyer",
      icon: lawyer,
      label: "Lawyer",
    },
    {
      id: "coach",
      icon: staff,
      label: "Coach",
    },
    {
      id: "player",
      icon: player,
      label: "Player",
    },
    {
      id: "staff",
      icon: staff,
      label: "Staff",
    },
    {
      id: "organizer",
      icon: organizer,
      label: "Organizer",
    },
  ];

  const handleConfirmBack = () => {
    dispatch(logout());
    navigate("/login");
  };

  const handleSelectType = (type) => {
    dispatch(setSignupData({ accountType: type }));
    dispatch(setVerificationStep("details"));
  };

  return (
    <>
      <div className="flex flex-col">
        <div className="mb-[60px] md:mb-0">
          <h2 className="text-[23px] leading-[28px] font-bold text-[#111927] mb-2">
            Get Started
          </h2>
          <p className="text-[14px] leading-[22px] text-[#6C737F] mb-10">
            Choose the account type
          </p>
        </div>

        <div className="flex justify-center w-full">
          <div className="grid md:grid-cols-3 grid-cols-2 gap-5  w-full">
            {accountTypes.map((type) => (
              <button
                key={type.id}
                onClick={() => handleSelectType(type.id)}
                className="group flex flex-col items-center justify-center p-[17px] rounded-[4px] border border-[#D8DADC] bg-white hover:border-[#2283FF]/20 hover:bg-[#2283FF]/5 transition-all duration-200 shadow-[0px_0px_0px_0.5px_rgba(0,0,0,0.03),0px_5px_22px_0px_rgba(0,0,0,0.04)] min-h-[90px]"
              >
                <div className="w-[39px] h-[39px] mb-1 flex items-center justify-center text-[#1A212F] group-hover:text-[#2283FF] transition-colors">
                  <img
                    src={type.icon}
                    alt={`${type.label} icon`}
                    className="w-7 h-7"
                  />
                </div>
                <span className="text-[14px] font-normal text-[#1A212F]/90 leading-[17px]">
                  {type.label}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>

      {showModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 max-w-md w-full mx-4">
            <h3 className="text-lg font-semibold text-gray-900 mb-2">
              Are you sure?
            </h3>
            <p className="text-gray-600 mb-6">
              Your account has been created, but leaving now will discard all
              subsequent changes. You'll need to log in again.
            </p>
            <div className="flex justify-end gap-4">
              <button
                onClick={() => setShowModal(false)}
                className="px-4 py-2 text-gray-600 hover:text-gray-900"
              >
                Cancel
              </button>
              <button
                onClick={handleConfirmBack}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Leave anyway
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default AccountTypeStep;
